// Verification-gate reason codes -> UI labels + human-readable descriptions.
// Codes come from the backend gate (services/verification.py -> verification_flags.reasons).
// Shared by the Listings table "Needs" column and the Listing edit modal so the two
// never drift.

export const REASON_LABELS = {
  beds_baths_mismatch: "beds/baths",
  floor_missing: "floor",
  floor_line_missing: "floor line",
  sqft_missing: "sqft",
  hoa_missing: "HOA",
  tax_missing: "tax",
  reno_no_description: "reno",
  reno_high_no_dw: "reno+DW",
  no_se_source: "SE link",
  whole_building_unit: "whole-bldg",
  possible_relist_dupe: "relist?",
};

// Fuller, sentence-length explanation of what's missing / wrong — used where there's
// room to spell it out (the edit modal), so a reviewer knows what to fix.
export const REASON_DESCRIPTIONS = {
  beds_baths_mismatch: "Beds/baths disagree across sources — confirm the correct count",
  floor_missing: "Floor is missing — set the unit's floor",
  floor_line_missing: "Floor line (stack) is missing",
  sqft_missing: "Square footage is missing or only estimated — enter a verified sqft",
  hoa_missing: "HOA / common charges are missing",
  tax_missing: "Monthly taxes are missing",
  reno_no_description: "No description to infer renovation level — set it manually",
  reno_high_no_dw: "High-reno unit with no dishwasher — confirm the dishwasher",
  no_se_source: "No StreetEasy link on file — add one",
  whole_building_unit: "Looks like a whole-building sale, not an individual unit",
  possible_relist_dupe: "Possible relist / duplicate — resolve it below",
};
